<template>
    <div id="vendors-items-container">
        <div class="row">
            <div class="col-12">
                <h4 class="page-title text-truncate">{{$t('VendorsListing.Title')}}</h4>
                <div class="row">
                    <div class="col-sm-12 col-md-3">                      
                        <MdButton
                            v-bind:Label="$t('VendorsListing.AddVendor')" 
                            v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                            v-bind:IconClass="'ti-plus pr-1'"
                            v-on:click="AddVendor"
                            v-bind:Name="'btn_add_vendor'">
                        </MdButton>
                    </div>

                    <div  class="col-sm-12 col-md-9 mb-4">
                        <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                            <div class="input-group" dir="ltr">
                                <input 
                                    type="text" 
                                    class="form-control"
                                    :dir="dirInput"
                                    v-model="parameter.SearchCriteria"   
                                    @keyup.enter="SearchVendors"                            
                                >
                                <div class="input-group-append">
                                    <div class="input-group-append">
                                        <MdButton 
                                            v-bind:Name="'btnsearchinput'"
                                            v-bind:VariantProp="'btn btn-sm search-attached'"
                                            v-bind:IconClass="'mdi mdi-magnify'"
                                            v-on:click="SearchVendors">
                                        </MdButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 mt-2">
                <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                <div class="row">
                    <div class="col-md-12">
                        <MdTable 
                            v-bind:fields="fields"
                            v-bind:items="items"
                            v-bind:totalRows="totalRows"
                            v-bind:isReadOnly="isReadOnly"
                            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                            v-bind:currentPage="currentPage"
                            v-bind:perPage="perPage"
                            v-bind:pageOptions="pageOptions"
                            v-bind:VisibleEditIcon="true"
                            v-bind:VisibleDeleteIcon="true"
                            :editIconEvent="EditVendor"
                            :deleteIconEvent="RemoveVendor"
                            :onRowSelected="onRowSelected"
                            :onFiltered="onFiltered"
                            :pageChanged="pageChanged"
                            :perPageFunction="PerPageFunction">
                        </MdTable>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PharmacyVedorsService from '@/services/pharmacyvendor.service'
import DBFunctions from '@/common/DBFunctions.js'
import ShowMessage from '@/components/messages/ShowMessage.js';
import Permission from '@/common/Permission'

export default {
    name: 'VendorsListing',
    mixins: [DBFunctions, ShowMessage, Permission],

    data() {
        return {
            OptionsRightMenu:{
                 visible:false,
                ItemsList:[],
                btnvisible:false,
                itemdisabled: false,
                favButtonAtion:false 
            }, 
            parameter: {
                SearchCriteria: '',
                PageNumber : 0,
                PageSize: 0 ,
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            fields: [
                { key: 'recId', sortable: true, label: 'ID', class: 'text-rigth hidden' },      
                { key: 'name', sortable: true, label: this.$t('Shared.Name'), class: 'text-rigth' },       
                { key: 'vendorcode', sortable: true, label: this.$t('Shared.Code'), class: 'text-rigth'},       
                { key: 'address1', sortable: true, label: this.$t('Shared.Address1'), class: 'text-rigth' },      
                { key: 'address2', sortable: true, label: this.$t('Shared.Address2'), class: 'text-rigth' },
                { key: 'phone', sortable: true, label: this.$t('Shared.Phone'), class: 'text-rigth' },
                { key: 'contact', sortable: true, label: this.$tc('Contact.Contact'), class: 'text-rigth' },  
                { key: 'city', sortable: true, label: this.$t('Shared.City'), class: 'text-rigth' }, 
                { key: 'state', sortable: true, label: this.$t('Shared.State'), class: 'text-rigth',formatter: this.formatPhone },    
                { key: 'zip', sortable: true, label: this.$t('Shared.Zip'), class: 'text-rigth' },
                { key: 'email', sortable: true, label: this.$t('Shared.Email'), class: 'text-rigth' },
                { key: 'fax', sortable: true, label: this.$t('Patient.LegalFax'), class: 'text-rigth' },
                { key: 'website', sortable: true, label: this.$t('insuranceSetup.WebSite'), class: 'text-rigth' },
                { key: 'remarks', sortable: true, label: this.$t('DrugOrderReturnedItems.Remarks'), class: 'text-rigth' },
                { key: 'isactive', sortable: true, label: this.$t('Shared.Active'), class: 'text-rigth' }, 
            ],
            pageOptions: [5, 10, 15 ],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            items: [],
            isReadOnly: false,
            ShowMessageIsEmpty:false,
            Mode:'', 
        }
    },

    methods: {
        AddVendor() {
            this.Mode = "Add";
            this.emitDataforFavorites();  
            this.$emit('onUpdatedMenu', '');  
            this.$router.push({ name: "vendorAdd" })
        },

        getVendorsListing() {
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;

            PharmacyVedorsService
                .getVendors(this.parameter)
                .then((response) => {
                    if(response.status == '200' && response.data && response.data.length > 0){
                        this.items = response.data;

                        let headerString = response.headers["x-pagination"];
                        const Header = JSON.parse(headerString);
                        this.totalRows = Header.TotalCount;
                    }

                    this.ShowMessageIsEmpty = this.items.length === 0;
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        EditVendor(row) {
            this.Mode = "Edit";
            this.$router.push({ name: "vendorEdit", params: {recId: row.recId} });
        },

        RemoveVendor(row) {
            this.$bvModal.msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
					title: this.$tc('Shared.DelRecord'),
					okTitle: this.$t('Shared.TitleDelete'),
					cancelTitle: this.$t('Shared.BtnCancel'),
					footerClass: 'p-2',
					titleClass: 'modal-title modal-type-warning',
                    id:'modal_delete_vendor'
				})
                .then(value => {
                    if(value){
                        PharmacyVedorsService.delete(row.recId)
                            .then(() => {
                                this.currentPage = 1;
                                this.SearchVendors();
                            })
                            .catch((error) => {
                                this.showResponseErrorMessage(error);
                            });
                    }
                })
        },

        pageChanged(page) {            
            this.currentPage = page;
            this.getVendorsListing();
        },

        PerPageFunction(perpage){
            this.perPage = perpage;
            this.currentPage = 1;
            this.getVendorsListing();
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },

        onRowSelected(items) {    
           this.selected = items;
        },

        SearchVendors() {
            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getVendorsListing();
        },

    },

    mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch(layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        this.$nextTick(() => {
            this.getVendorsListing();
        });
    }
}
</script>